import { fromAppointmentTypeQueryToAppointmentType } from "../../../../../adapters/v3/pages/BookAppointment/adapters/from-appointment-type-query-to-appointment-type.js";
import { GET_BOOK_APPOINTMENT_TYPE } from "../../../../../queries/v3/pages/BookAppointment/queries/get-book-appointment-type.js";
const getBookAppointmentType = async (apolloClient, id, locale) => {
  if (id === void 0) {
    return null;
  }
  try {
    const { data, error } = await apolloClient.query({
      query: GET_BOOK_APPOINTMENT_TYPE,
      variables: {
        id
      },
      ...locale ? {
        context: {
          forwardHeaders: {
            "Accept-Language": locale
          }
        }
      } : {}
    });
    const appointmentTypeQueryData = data?.appointmentType;
    const appointmentTypeData = fromAppointmentTypeQueryToAppointmentType(appointmentTypeQueryData);
    if (error) {
      console.error(error);
    }
    return appointmentTypeData;
  } catch (error) {
    console.error(error);
    return null;
  }
};
export {
  getBookAppointmentType
};
//# sourceMappingURL=book-appointment-type.js.map
